// Services
import ResetPasswordService from '@/services/ResetPasswordService';

// Event Bus
import { EventBus } from '@/EventBus.js';

export default {

  name: 'resetPassword',

  components: {

  },

  data: function() {
    return {
      newPassword: null,
      tokenValid: false,
      passwordSaved: false,
      token: null
    }
  },

  mounted: function() {
    if(this.$route.params.token) {
      ResetPasswordService.checkToken(this.$route.params.token)
        .then((res) => {
          this.tokenValid = true;
        })
        .catch((err) => {
          if(err.response.status == 404) {
            EventBus.dispatchErrorEvent('Whoops! This reset link is not valid, please try to reset your password again.');
          }
          else {
            EventBus.dispatchErrorEvent('Whoops! Something went wrong, please try again.');
          }
        });
    }
    else {
      EventBus.dispatchErrorEvent('Whoops! This reset link is not valid, please try to reset your password again.');
    }
  },

  methods: {
    doSavePassword: function() {
      if(this.newPassword && this.newPassword.trim().length > 0) {
        ResetPasswordService.saveNewPassword(this.$route.params.token, this.newPassword)
        .then((res) => {
          this.passwordSaved = true;
        })
        .catch((err) => {
          if(err.response.status == 404) {
            EventBus.dispatchErrorEvent('Whoops! This reset link is not valid, please try to reset your password again.');
          }
          else {
            EventBus.dispatchErrorEvent('Whoops! Something went wrong, please try again.');
          }
        });
      }
      else {
        EventBus.dispatchErrorEvent('Whoops! Password may not be empty.');
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/ResetPassword/ResetPassword.js